import { ReactNode } from "react";
import { BehaviorSubject } from "rxjs";

export type InfoScreenType = "info" | "success" | "warning" | "danger"


export const infoOpen$ = new BehaviorSubject<boolean>(false);
export const infoType$ = new BehaviorSubject<InfoScreenType>("info");
export const infoTitle$ = new BehaviorSubject<ReactNode>("");
export const infoSubTitle$ = new BehaviorSubject<ReactNode>("");
export const infoContent$ = new BehaviorSubject<ReactNode>("");
export const showClose$ = new BehaviorSubject<boolean>(false);


type InfoScreenSetupType = {
    type?: InfoScreenType,
    title?: ReactNode,
    subtitle?: ReactNode,
    content?: ReactNode,
    showClose?: boolean,
    onOpen?: () => void
}

class InfoScreen {

    setupInfo: InfoScreenSetupType = {
        type: "info",
        title: "",
        subtitle: "",
        content: "",
        showClose: false,
        onOpen: () => { }
    }

    setup(
        { type = "info", title = "", subtitle = "", content = "", showClose = false, onOpen }: InfoScreenSetupType
    ): void {

        this.setupInfo = { type, title, subtitle, content, showClose, onOpen }
        infoType$.next(type);
        infoTitle$.next(title);
        infoSubTitle$.next(subtitle);
        infoContent$.next(content);
    }

    open(): void {
        setTimeout(() => {
            if (this.setupInfo.onOpen) {
                this.setupInfo.onOpen();
            }
            infoOpen$.next(true);
        }, 500)
    }

    close(): void {

        setTimeout(() => {
            infoOpen$.next(false);
            setTimeout(() => {
                this.setup({});
            }, 500)
        }, 500)
    }

}

const infoScreen = new InfoScreen();


export { infoScreen }